import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ContentProvider, useContent } from "./context/ContentContext";
import { resolveAsset } from "./lib/api";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Historia } from "./components/Historia";
import { Trayectoria } from "./components/Trayectoria";
import { Proyectos } from "./components/Proyectos";
import { Galeria } from "./components/Galeria";
import { Contacto, Footer } from "./components/Contacto";
import AdminPage from "./pages/AdminPage";
import ResetPage from "./pages/ResetPage";

function PublicSite() {
  const { content } = useContent();
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [content]);

  return (
    <div className="min-h-screen">
      <div
        className="site-bg"
        style={{ backgroundImage: `url(${resolveAsset(content.photos?.fondo) || "/assets/fondo.jpg"})` }}
        aria-hidden="true"
      />
      <div className="site-bg-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Historia />
        <Trayectoria />
        <Proyectos />
        <Galeria />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
}

export default App;

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/reset" element={<ResetPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </ContentProvider>
  );
}
